import { useErrorMessage } from '@nucleus-commerce/admin-kit/errors';
import { Alert, AlertDescription } from '@nucleus-commerce/ui/components/alert';

export interface ServerErrorProps {
  error: unknown;
  /** Replaces the catalog message when the caller knows better (a code with local meaning). */
  message?: string | null | undefined;
}

/** Inline error for forms that opt out of the global toast. */
export function ServerError({ error, message }: ServerErrorProps) {
  const resolve = useErrorMessage();
  if (error === null || error === undefined) return null;
  return (
    <Alert variant="destructive">
      <AlertDescription>{message ?? resolve(error)}</AlertDescription>
    </Alert>
  );
}
